import utils from 'utils'

class dataCollectionCtrl {
  constructor($scope, $uibModal, logger, httpRequest, $state, initSortService, $timeout, $rootScope, sweetalert) {
    const types = ['inv_type', 'invoice_nature', 'special_inv_type', 'collect_flag']
    httpRequest.get_dictByTypeArr(types).then((res) => {
      $scope.dictData = res.data.value
    })
    $scope.ovatBill = {}
    $scope.ovatBill.collectAll = '0'
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    $scope.selectedList = [] // 已选择的数据
    $scope.kdAccountIdDic = []
    $scope.isClicked = false //防误触

    const aMonth = utils.genPeriodByMonth()
    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        billCode: '',
        custNameOrCreditCode: '',
        invoiceNature: '',
        invoiceType: '',
        billDateStart: aMonth.start,
        billDateEnd: aMonth.end,
        matName: '',
        collectFlag: '0',
        kdAccountId: '',
      },
    }
    $scope.reset = function () {
      $scope.queryParam.param = {
        billCode: '',
        custNameOrCreditCode: '',
        invoiceNature: '',
        invoiceType: '',
        billDateStart: aMonth.start,
        billDateEnd: aMonth.end,
        matName: '',
        collectFlag: '0',
        kdAccountId: $scope.kdAccountIdDic.length ? $scope.kdAccountIdDic[0].kdAccountId : '',
      }
    }
    httpRequest.get_getSelectKdAccountListByTenantId(userInfo.tenantId).then((res) => {
      const kdAccountIdDicList = res.data.value
      if (kdAccountIdDicList) {
        $scope.kdAccountIdDic = []
        kdAccountIdDicList.forEach(({
          acctName,
          kdAccountId
        }) => {
          $scope.kdAccountIdDic.push({
            acctName,
            kdAccountId: kdAccountId.toString()
          })
        })
        $scope.queryParam.param.kdAccountId = $scope.kdAccountIdDic[0] && $scope.kdAccountIdDic[0].kdAccountId
      } else {
        $scope.kdAccountIdDic = []
      }
      queryBillOfPage()
    })

    const queryBillOfPage = function () {
      const sessionParam = sessionStorage.dataCollectionParam && JSON.parse(sessionStorage.dataCollectionParam)
      $scope.queryParam = (sessionParam && sessionParam.param.kdAccountId != '') ? sessionParam : $scope.queryParam
      httpRequest.post_qryBillOfPage($scope.queryParam).then((res) => { //post_pageBill
        $scope.ovatBill.list = res.data.value ? res.data.value.list : []
        $scope.initTotalNum = $scope.totalItems ? 0 : res.data.value.total //记录第一次查询到的总数
        $scope.totalItems = res.data.value ? res.data.value.total : 0
        $scope.selectedList = []
      })
    }
    // ie 滚动条遮盖内容
    $('body').addClass('stick-ie-scrollbar')
    $scope.$on('$stateChangeStart', () => {
      $('body').removeClass('stick-ie-scrollbar')
    })

    // 表头排序
    $scope.orderMap = initSortService('dataCollectionParam')
    $scope.selectedHandle = function () {
      $scope.queryParam.orderMap = {}
      if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
      sessionStorage.setItem('dataCollectionParam', JSON.stringify($scope.queryParam))
      queryBillOfPage()
    }

    $scope.customizedConfig = {
      version: 1.17,
      queryForm: [{
        label: '单据编号',
        selected: true,
        default: true,
      }, {
        label: '购方名称/信用代码',
        selected: false,
        default: false,
      }, {
        label: '发票性质',
        selected: false,
        default: false,
      }, {
        label: '发票种类',
        selected: false,
        default: false,
      }, {
        label: '单据日期',
        selected: true,
        default: true,
      }, {
        label: '主商品名称',
        selected: false,
        default: false,
      }, {
        label: '采集标识',
        selected: true,
        default: true,
      }, {
        label: '采集套账',
        selected: true,
        default: true,
      }, {
        label: '扩展1',
        selected: false,
        default: false,
      }, {
        label: '扩展2',
        selected: false,
        default: false,
      }, {
        label: '扩展3',
        selected: false,
        default: false,
      }],
      table: [{
        label: '单据编号',
        selected: true,
        default: true,
      }, {
        label: '发票种类',
        selected: true,
        default: true,
      }, {
        label: '购方名称',
        selected: true,
        default: true,
      }, {
        label: '购方信用代码',
        selected: true,
        default: true,
      }, {
        label: '购方地址电话',
        selected: true,
        default: true,
      },{
        label: '购方开户行及账号',
        selected: true,
        default: true,
      },{
        label: '主商品名称',
        selected: true,
        default: true,
      }, {
        label: '合计金额',
        selected: true,
        default: true,
      }, {
        label: '合计税额',
        selected: true,
        default: true,
      }, {
        label: '价税合计',
        selected: true,
        default: true,
      },{
        label: '备注',
        selected: true,
        default: true,
      }, {
        label: '单据日期',
        selected: true,
        default: true,
      }, {
        label: '采集标识',
        selected: true,
        default: true,
      }, {
        label: '销方税号',
        selected: false,
        default: false,
      }, {
        label: '销方银行账号',
        selected: false,
        default: false,
      }, {
        label: '购方手机',
        selected: false,
        default: false,
      }, {
        label: '购方邮箱',
        selected: false,
        default: false,
      }, {
        label: '扩展1',
        selected: false,
        default: false,
      }, {
        label: '扩展2',
        selected: false,
        default: false,
      }, {
        label: '扩展3',
        selected: false,
        default: false,
      }],
    }

    $scope.toDetail = function (item) {
      //$state.go('outputManage.FOManage.ovatBill.checkBillDetail', { billId: item.billid })
      const url = $state.href('outputManage.FOManage.ovatBill.checkBillDetail', {
        obj: JSON.stringify({
          billId: item.billId,
          kdAccountId: (sessionStorage.dataCollectionParam && JSON.parse(sessionStorage.dataCollectionParam).param.kdAccountId) || $scope.queryParam.param.kdAccountId || '0'
        })
      }, {
        reload: true,
      })
      window.open(url, '_blank')
    }
    // 页面跳转
    $scope.pageChanged = function () {
      sessionStorage.setItem('dataCollectionParam', JSON.stringify({
        orderMap: $scope.queryParam.orderMap,
        pageNum: $scope.queryParam.pageNum,
        pageSize: $scope.queryParam.pageSize,
        param: sessionStorage.dataCollectionParam ? JSON.parse(sessionStorage.dataCollectionParam).param : {
          billCode: '',
          custNameOrCreditCode: '',
          invoiceNature: '',
          invoiceType: '',
          billDateStart: aMonth.start,
          billDateEnd: aMonth.end,
          matName: '',
          collectFlag: '0',
          kdAccountId: $scope.kdAccountIdDic.length ? $scope.kdAccountIdDic[0].kdAccountId : '',
        },
      }))
      queryBillOfPage()
    }

    // 搜索
    $scope.search = function () {
      sessionStorage.setItem('dataCollectionParam', JSON.stringify($scope.queryParam))
      queryBillOfPage()
    }

    // modal 
    $scope.resultModal = function (reqVal) {
      $timeout(() => {
        // 弹窗实例
        const modalInstance = $uibModal.open({
          templateUrl: 'importOvatBillModalContentCtrl.html',
          controller: ['$scope', '$uibModalInstance', 'httpRequest', 'items1', ($scope, $uibModalInstance, httpRequest, items1) => {
            $scope.modaldata = {}
            $scope.modaldata = items1

            $scope.pageModalImportOpt = {
              totalItems: $scope.modaldata.params.data.total, // 组件初始化设置总页数
              currentPage: ++$scope.modaldata.params.data.prePage, // 设置显示第一页
              maxSize: $scope.modaldata.params.data.pageSize, // 每一叶显示记录数
            }
            // 页码操作
            $scope.pageModalImportChanged = function () {
              const _req = {
                pageNum: $scope.pageModalImportOpt.currentPage,
                pageSize: $scope.pageModalImportOpt.maxSize,
                param: $scope.modaldata.params.batchNo,
              }
              httpRequest.post_getCollectResult(_req).then((res) => {
                $scope.modaldata.params.data = res.data.value
                $scope.pageModalImportOpt = {
                  totalItems: $scope.modaldata.params.data.total, // 组件初始化设置总页数
                  currentPage: ++$scope.modaldata.params.data.prePage, // 设置显示第一页
                  maxSize: $scope.modaldata.params.data.pageSize, // 每一叶显示记录数
                }
              })
            }

            $scope.downBatchInfo = function () {
              window.open(`${host.etcloudOvat}dlTaskService/downBatchInfoDetail?batchNo=${$scope.modaldata.params.batchNo}&accessToken=${$scope.modaldata.idToken}`)
            }
            $scope.cancel = function () {
              $uibModalInstance.dismiss()
            }
          }],
          backdrop: 'static',
          openedClass: 'mod-modal-importexcel mod-modal mod-modal-lg',
          backdrop: 'static',
          animation: true,
          resolve: {
            items1() {
              return reqVal
            },
          },
        })
        modalInstance.result.then((res) => {
          //queryBillOfPage()
        }, (error) => {
          logger.logError(error)
        })
      }, 200)
    }

    // modal 
    $scope.collectData = function () {
      if ($scope.isClicked == true) {
        return
      }
      $scope.isClicked = true
      httpRequest.get_getDataSourcesConfigByTenantId(userInfo.tenantId).then((res) => {
        if (res.data.value) {
          if (!JSON.parse(localStorage.user_info).sale) {
            logger.logError('该机构未配置纳税人信息，不能进行该操作')
            $scope.isClicked = false
            return
          }
          if ($scope.selectedList.length == 0 && $scope.ovatBill.collectAll == '0') {
            logger.logError('还未选择数据')
            $scope.isClicked = false
            return
          }
          const isCollected = $scope.selectedList.some(x => x.collectflag == '1')
          if (isCollected && $scope.ovatBill.collectAll == '0') {
            logger.logError('存在已采集数据，请重新选择')
            $scope.isClicked = false
            return
          }
          if ($scope.initTotalNum > 4000 && $scope.ovatBill.collectAll == '1') {
            sweetalert.confirm('提示', '本次采集的数据超过系统最大限制条数，是否继续采集？若选择是则系统默认取前4000条数据').then(() => {
              $scope.modelUKey()
            }).finally(() => {
              $scope.isClicked = false
            })
          } else {
            $scope.modelUKey()
          }
        } else {
          $scope.isClicked = false
        }
      }, (error) => {
        $scope.isClicked = false
      })
    }

    //选择开票点
    $scope.modelUKey = function () {
      $scope.item = {}
      $scope.item.code = 'OVAT_BILL'
      const modalInstance = $uibModal.open({
        templateUrl: 'dataCollectionModal.html',
        controller: 'ovatBillModalCtrl',
        openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
        backdrop: 'static',
        resolve: {
          items1() {
            return $scope.item
          },
        },
      })
      modalInstance.result.then((res) => {
        const billIdList = $scope.selectedList.map(x => x.billId)
        const ukeyId = res.ukeyId
        const paramObj = {
          // "batchNo": "string",
          billIdList,
          customSearchParam: $scope.queryParam.param,
          isCollectAll: $scope.ovatBill.collectAll,
          kdAccountId: $scope.queryParam.param.kdAccountId,
          ukeyId
        }
        $scope.isClicked = false
        $scope.batchCollect(paramObj)
      }, () => {
        $scope.isClicked = false
      })
    }

    $scope.batchCollect = function (param) {
      utils.loading('正在采集，请稍候')
      httpRequest.post_batchCollectBills(param).then((result) => {
        const {
          batchNo
        } = result.data.value
        if (batchNo) {
          const paramObj = {
            pageNum: 1,
            pageSize: 10,
            param: batchNo
          }
          httpRequest.post_getCollectResult(paramObj).then((res) => {
            const resultData = res.data.value
            const modalData = { // 返回给弹窗的数据 
              idToken: $rootScope.idToken,
              params: {
                batchNo,
                data: resultData,
              },
            }
            httpRequest.get_getCollectCountResult(batchNo).then((res1) => {
              modalData.countInfo = res1.data.value
              modalData.countInfo.successCount = modalData.countInfo.sourceCount - modalData.countInfo.errorCount
              utils.loaded()
              $scope.resultModal(modalData)
            })
          })
        }
      }).finally(() => {
        utils.loaded()
        queryBillOfPage()
      })
    }
  }
}
dataCollectionCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'initSortService', '$timeout', '$rootScope', 'sweetalert']
export default dataCollectionCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/dataCollectionCtrl.js